import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

/** Всплывающая панель — меню, список выбора, подсказки, выпадашки тулбара: одна семья. */
export const POPOVER = 'bg-white border border-gray-300 rounded-md shadow-lg p-1 text-sm';
